import React from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import FAQsPage from "./pages/Faq";
import HelpCenter from "./pages/HelpCenter";
import BlogsPage from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Auth from "./components/routes/AuthRouter";
import TermsOfService from "./pages/TermsOfService";
import Careers from "./pages/Careers";
import JobDetail from "./pages/JobDetail";
import ApplicationPage from "./pages/ApplicationForm";
import ScrollToTop from "./components/routes/ScrollToTop";

export const PlatformRoutes: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* Routes that share the Navbar */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/faq" element={<FAQsPage />} />
          <Route path="/help" element={<HelpCenter />} />
          <Route path="/blog" element={<BlogsPage />} />
          <Route path="/careers/:id" element={<JobDetail />} />
          <Route path="/careers/apply/:id" element={<ApplicationPage />} />
          <Route path="/blogs/:slug" element={<BlogPost />} />
        </Route>

        {/* Routes without Navbar (e.g., login/register) */}
        <Route path="/*" element={<Auth />} />
      </Routes>
    </>
  );
};
